module.exports = __webpack_public_path__ + "static/media/icon-arrow.0a37ac05.svg";